import { Modal } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { AppButton } from '../AppButton/AppButton';
import './AppRangeCalender.scss';
import AppDatePicker from '../AppDatePicker/AppDatePicker';

export const AppRangeCalender = ({
  open,
  handleClose,
  onSelectDate,
  dateRange,
}: {
  open: boolean;
  handleClose: () => void;
  onSelectDate: (range: { start: Date; finish: Date }) => void;
  dateRange: { start: Date; finish: Date };
}) => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [finishDate, setFinishDate] = useState<Date | null>(null);

  const handleStartDate = (value: Date) => {
    setStartDate(value);
    if (!finishDate) {
      const year = value.getFullYear();
      const month = value.getMonth();
      const lastDayOfMonth = new Date(year, month + 1, 0);
      setFinishDate(lastDayOfMonth);
    }
  };

  const handleFinishDate = (value: Date) => {
    setFinishDate(value);
  };

  useEffect(() => {
    if (startDate && finishDate && !open) {
      onSelectDate({ start: startDate, finish: finishDate });
    }
    if (open && dateRange) {
      setStartDate(dateRange.start);
      setFinishDate(dateRange.finish);
    }
  }, [open]);

  return (
    <Modal open={open}>
      <div className="range-calender-success-modal-content">
        <h1 className="range-calender-header">Select Range</h1>
        <div className="range-date-container mb-2">
          <div className="full">
            <AppDatePicker
              label="Start"
              onDateSelected={(date) => date && handleStartDate(date)}
              selectedDate={startDate}
              dateFormat="MMM yyyy"
              showMonthYearPicker
              maximumDate={finishDate || undefined}
              onDateSelect={(date, event) => event.stopPropagation()}
            />
          </div>
          <div className="full ml-4">
            <AppDatePicker
              label="Finish"
              onDateSelected={(date) => {
                if (date) {
                  const year = date.getFullYear();
                  const month = date.getMonth();
                  const lastDayOfMonth = new Date(year, month + 1, 0);
                  handleFinishDate(lastDayOfMonth);
                }
              }}
              selectedDate={finishDate}
              dateFormat="MMM yyyy"
              showMonthYearPicker
              minumumDate={startDate || undefined}
              onDateSelect={(date, event) => event.stopPropagation()}
            />
          </div>
        </div>
        <AppButton text="Close" type="TERTIARY" onClick={handleClose} />
      </div>
    </Modal>
  );
};
